import { Export } from "@phosphor-icons/react";
import { useState } from "react";
import { toast } from "react-toastify";

import { Button } from "common/components/ui/Button";

import useAudienceMutations from "../../../../datahooks/useAudienceMutations";
import ExportAudienceDialog from "./ExportAudienceDialog";

import type { AudienceFilters, AudienceProfile } from "../../../../types";

interface ExportAudienceProps {
  audience: AudienceProfile[];
  selectedProfiles: AudienceProfile[];
  isDisabled: boolean;
  filters: AudienceFilters;
}

export default function ExportAudience({
  audience,
  selectedProfiles,
  isDisabled,
  filters,
}: ExportAudienceProps) {
  const { exportAudience, isExporting } = useAudienceMutations();

  const [exportUrl, setExportUrl] = useState<string>();

  // Filter out any undefined or null profiles before passing to exportProfilesToCSV
  const validSelectedProfiles = selectedProfiles.filter(
    (profile) => profile != null,
  );
  const validAudience = audience.filter((profile) => profile != null);

  // Use the filtered arrays
  const profiles = validSelectedProfiles.length
    ? validSelectedProfiles
    : validAudience;

  let text = "Export ";
  if (validSelectedProfiles.length) {
    text += `${validSelectedProfiles.length} Target${validSelectedProfiles.length > 1 ? "s" : ""}`;
  } else {
    text += "audience";
  }

  const handleExportAudience = async () => {
    // Get the export URL
    const url = await exportAudience(filters);

    // Set the export URL
    setExportUrl(url);

    // Show a toast to the user
    toast("Your export is preparing, you will be notified when it's ready");
  };

  return (
    <>
      <ExportAudienceDialog
        isOpen={!!exportUrl}
        onOpenChange={() => setExportUrl(null)}
        exportUrl={exportUrl}
      />

      <Button
        className="flex-1"
        variant="secondary-purple"
        leftIcon={<Export weight="fill" />}
        disabled={profiles.length === 0 || isDisabled}
        isLoading={isExporting}
        onClick={handleExportAudience}
      >
        <span className="truncate">{text}</span>
      </Button>
    </>
  );
}
